import axios from 'axios';

const api = axios.create({
  baseURL: 'https://fasttrackapi.read21.org/api' || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

const token = localStorage.getItem('admin_token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error('[API REQUEST ERROR]', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('[API RESPONSE ERROR]', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
      responseData: error.response?.data,
    });
    
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/admin/login');
      const isOnLoginPage = window.location.pathname === '/login';
      
      if (!isLoginRequest && !isOnLoginPage) {
        localStorage.removeItem('admin_token');
        delete api.defaults.headers.common['Authorization'];
        window.location.href = '/login';
      } else {
        localStorage.removeItem('admin_token');
        delete api.defaults.headers.common['Authorization'];
      }
    }
    return Promise.reject(error);
  }
);

export default api;


